export const MAIN_ROUTE = "/";
export const NOUVEAUTES_ROUTE = "/nouveautes";
export const ARRIVES_ROUTE = "/arrives";
export const ADMIN_LOGIN_ROUTE = "/admin";
export const PRODUCT_ROUTE = "/product";
export const PRODUCT_REVIEWS_ROUTE = (productId) => `/product/${productId}/reviews`;
export const CONTACT_ROUTE = "/contact";
export const TERMS_ROUTE = "/conditions-generales";
export const CUSTOMER_PROFILE_ROUTE = "/customer-profile";
export const CART_ROUTE = "/cart";
export const CHECKOUT_ROUTE = "/cart/checkout";
export const ORDER_ROUTE = (orderId) => `/orders/${orderId}`;
export const ADMIN_PROFILE_ROUTE = "/admin-profile";

/** Customer-only pages that require login (guests see the auth prompt instead of content). */
export function isCustomerProtectedPath(pathname) {
    if (pathname === CART_ROUTE || pathname === CHECKOUT_ROUTE) {
        return true;
    }
    if (pathname === CUSTOMER_PROFILE_ROUTE || pathname.startsWith(`${CUSTOMER_PROFILE_ROUTE}/`)) {
        return true;
    }
    if (pathname.startsWith("/orders/")) {
        return true;
    }
    return false;
}

export const ROLES = {
    CUSTOMER: "CUSTOMER",
    ADMIN: "ADMIN",
    MANAGER: "MANAGER",
    SECRETARY: "SECRETARY"
};

/** Company branding (frontend-only; not loaded from the API or editable in admin). */
export const STORE_NAME = "Global 4 Automobile";
/** Suffix after the product name in the browser tab on product pages. */
export const PRODUCT_PAGE_TITLE_SUFFIX = "Commandez et recevez avec livraison gratuite chez Global4Automobile.com";
/**
 * Fallback legal entity name if store-info has not loaded yet.
 * Prefer `storeInfo.legalName` from admin → Informations légales.
 */
export const STORE_LEGAL_NAME = "Global 4 Automobile SARL";

/** Set to true to show shop addresses in the top menu header contacts block. */
export const SHOW_HEADER_SHOP_ADDRESSES = false;

/** Set to true to show country-of-origin flags on catalog and product images. */
export const COUNTRY_ORIGIN_BANNER_ENABLED = false;

/**
 * Catalogue highlight popup: minimum time between shows (browser localStorage).
 * Not an env/API setting — change here only.
 */
export const PRODUCT_HIGHLIGHT_POPUP_COOLDOWN_MS = 15 * 60 * 1000;

/** localStorage key for highlight popup cooldown + last shown product id. */
export const PRODUCT_HIGHLIGHT_POPUP_STORAGE_KEY = "storefront.productHighlightPopup";

export const PRODUCT_STATUSES = ["CREATED", "READY", "DELETED"];

export const LOT_STATUSES = ["CREATED", "READY", "ARCHIVED", "DELETED"];
